import * as API from 'common/constant/routes'
import { getJson, postJson } from 'helper/http'
import toSnakeCase from '@hellofiremind/map-keys-case/to-snake-case'

export const getUsers = (sort, direction, limit, start) => getJson(API.GET_USERS, {}, toSnakeCase({ direction, limit, sort, start }))
export const getAllUsers = () => getJson(API.GET_ALL_USERS)
export const changeUserStatus = (uuid) => postJson(API.DISABLE_USER, {}, { uuid })
export const deleteUser = (uuid) => postJson(API.DELETE_USER, {}, { uuid })
export const editUser = (userObject) => postJson(API.EDIT_USER, {}, { ...userObject })
export const addUser = (userObject) => postJson(API.ADD_USER, {}, { ...userObject })
export const searchUser = (searchTerm, sort, direction, limit, start) => getJson(API.SEARCH_USERS, {}, toSnakeCase({ direction, limit, searchTerm, sort, start }))
export const getUserTypes = (exception) => getJson(API.GET_USER_TYPES, {}, { exception })
export const updateEmailPreference = (email, userUuid) => postJson(API.UPDATE_EMAIL_PREFERENCE, {}, { email: email, uuid: userUuid })
export const updateLocationPreference = (preference, userUuid) => postJson(API.UPDATE_LOCATION_PREFERENCE, {}, { preference, uuid: userUuid })
export const updateTC = (preference, userUuid) => postJson(API.UPDATE_TC, {}, { preference, userUuid })
